import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

export default function CtaBanner() {
    return (
        <section
            data-testid="cta-banner"
            className="relative overflow-hidden bg-tl-orange py-20 md:py-28"
        >
            <span
                aria-hidden="true"
                className="pointer-events-none absolute -right-10 top-1/2 hidden -translate-y-1/2 select-none font-display text-[16rem] font-extrabold leading-none text-tl-dark/10 lg:block"
            >
                TL
            </span>
            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
                <Reveal>
                    <p className="font-mono-tl text-xs uppercase tracking-[0.35em] text-tl-dark/70">
                        Preventivo senza impegno
                    </p>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-5 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-tl-dark sm:text-4xl lg:text-5xl">
                        Hai un progetto da realizzare?
                    </h2>
                </Reveal>
                <Reveal delay={0.18}>
                    <p className="mt-6 max-w-xl text-base leading-relaxed text-tl-dark/80 sm:text-lg">
                        Inviaci la tua richiesta e raccontaci di cosa hai bisogno.
                        Valuteremo insieme la soluzione più adatta.
                    </p>
                </Reveal>
                <Reveal delay={0.26}>
                    <button
                        type="button"
                        data-testid="cta-banner-button"
                        onClick={() => scrollToId("contatti")}
                        className="group mt-10 inline-flex items-center gap-3 bg-tl-dark px-9 py-4 font-mono-tl text-sm font-semibold uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:bg-tl-dark3"
                    >
                        Richiedi un preventivo
                        <ArrowRight
                            size={16}
                            className="transition-transform duration-300 group-hover:translate-x-1"
                        />
                    </button>
                </Reveal>
            </div>
        </section>
    );
}
